/// <amd-module name="Artifacts/Upack/services/UPackDataService" />
// import { HubWebPageDataService } from "Feed/Legacy/DataServices/WebPageDataService";
import { BatchExecutor, IBatchIterator } from "Artifacts/Package/services/BatchHandling";
import { MinimalPackageDetails } from "Artifacts/Root/types/PackagingShared";
import * as VSS_UPackApi_Contracts from "Artifacts/Upack/Contracts/UPackApi";
import { getUPackApiClient, IUPackApiRestClient } from "Artifacts/Upack/RestClient/UPackApi";
import { IVssService, Services, VssService } from "VSS/Platform/Context";

// import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

export interface IFeedUPackDataService extends IVssService {
  batchSize: number;
  batchDelete(
    feedId: string,
    iterator: IBatchIterator<MinimalPackageDetails[]>,
    projectId?: string,
  ): Promise<void>;
  batchRestoreToFeed(
    feedId: string,
    iterator: IBatchIterator<MinimalPackageDetails[]>,
    projectId?: string,
  ): Promise<void>;
  batchPermanentlyDelete(
    feedId: string,
    iterator: IBatchIterator<MinimalPackageDetails[]>,
    projectId?: string,
  ): Promise<void>;
  batchPromote(
    feedId: string,
    viewId: string,
    iterator: IBatchIterator<MinimalPackageDetails[]>,
    projectId?: string,
  ): Promise<void>;
}

class UPackDataService extends VssService implements IFeedUPackDataService {
  get UPackApiRestClient(): IUPackApiRestClient {
    return getUPackApiClient(this.pageContext);
  }

  get batchSize() {
    return 100; // SGV TODO
    // return this.pageContext
    // 	.getService<HubWebPageDataService>("IFeedWebPageDataService")
    // 	.getBatchOperationPageSize();
  }

  public async batchDelete(
    feedId: string,
    iterator: IBatchIterator<MinimalPackageDetails[]>,
    projectId?: string,
  ): Promise<void> {
    await BatchExecutor.executeInParallel(
      iterator,
      async (packageDetails: MinimalPackageDetails[]) => {
        const batchRequest = <VSS_UPackApi_Contracts.UPackPackagesBatchRequest>{
          data: null,
          operation: VSS_UPackApi_Contracts.UPackBatchOperationType.Delete,
          packages: packageDetails,
        };
        await this.UPackApiRestClient.updatePackageVersions(batchRequest, feedId, projectId);
      },
    );
  }

  public async batchRestoreToFeed(
    feedId: string,
    iterator: IBatchIterator<MinimalPackageDetails[]>,
    projectId?: string,
  ): Promise<void> {
    await BatchExecutor.executeInParallel(
      iterator,
      async (packageDetails: MinimalPackageDetails[]) => {
        const batchRequest = <VSS_UPackApi_Contracts.UPackPackagesBatchRequest>{
          data: null,
          operation: VSS_UPackApi_Contracts.UPackBatchOperationType.RestoreToFeed,
          packages: packageDetails,
        };
        await this.UPackApiRestClient.updateRecycleBinPackageVersions(
          batchRequest,
          feedId,
          projectId,
        );
      },
    );
  }

  public async batchPermanentlyDelete(
    feedId: string,
    iterator: IBatchIterator<MinimalPackageDetails[]>,
    projectId?: string,
  ): Promise<void> {
    await BatchExecutor.executeInParallel(
      iterator,
      async (packageDetails: MinimalPackageDetails[]) => {
        const batchRequest = <VSS_UPackApi_Contracts.UPackPackagesBatchRequest>{
          data: null,
          operation: VSS_UPackApi_Contracts.UPackBatchOperationType.PermanentDelete,
          packages: packageDetails,
        };
        await this.UPackApiRestClient.updateRecycleBinPackageVersions(
          batchRequest,
          feedId,
          projectId,
        );
      },
    );
  }

  public async batchPromote(
    feedId: string,
    viewId: string,
    iterator: IBatchIterator<MinimalPackageDetails[]>,
    projectId?: string,
  ): Promise<void> {
    await BatchExecutor.executeInParallel(
      iterator,
      async (packageDetails: MinimalPackageDetails[]) => {
        const batchRequest = <VSS_UPackApi_Contracts.UPackPackagesBatchRequest>{
          data: { viewId },
          operation: VSS_UPackApi_Contracts.UPackBatchOperationType.Promote,
          packages: packageDetails,
        };
        await this.UPackApiRestClient.updatePackageVersions(batchRequest, feedId, projectId);
      },
    );
  }
}

Services.add("IFeedUPackDataService", { serviceFactory: UPackDataService });
